import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserManagerService } from '../../../core/services/user-manager.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	templateUrl: './confirm-password-modal.component.html'
})
export class ConfirmPasswordModalComponent implements OnInit {
	public form!: FormGroup;
	public formSubmitted: boolean = false;
	
	constructor(
		public activeModal: NgbActiveModal,
		private formBuilder: FormBuilder,
		private userManagerService: UserManagerService,
		private toastrService: ToastrService
	) { }

	ngOnInit() {
		this.form = this.formBuilder.group({
			password: new FormControl(null, [Validators.required, Validators.minLength(1)]),
		});
	}

	public formSubmit(): void {
		if (this.formSubmitted) return;

		this.formSubmitted = true;

		this.userManagerService.postConfirmPassword({
			password: (this.form.get('password') as FormControl).value
		})
			.subscribe((isAnAuthenticatedUser: boolean) => {
				if (!isAnAuthenticatedUser) {
					this.toastrService.clear();
					this.toastrService.error('Senha inválida', 'Acesso negado!');
				}

				this.formSubmitted = false;
				this.closeModal(isAnAuthenticatedUser);
			}, err => {
				this.toastrService.clear();
				this.toastrService.error('Senha inválida', 'Acesso negado!');
				this.formSubmitted = false;
				this.closeModal(false);
			});
	}

	public closeModal(action: boolean) {
		this.activeModal.close(action);
	}
}
